/** Why a secret comes back blank, before anyone replaces it. */
export function WriteOnlyNotice({
  secret = "The Azure connection string",
}: {
  /** What is write-only, as the sentence starts, e.g. "The client secret". */
  secret?: string;
}) {
  return (
    <div className="alert alert-warning mb-0">
      <p className="fw-semibold mb-1">Secret values are write-only</p>
      <p className="mb-0">
        {secret} is not displayed after save. Make a note of any replacement
        value before saving.
      </p>
    </div>
  );
}

export default WriteOnlyNotice;
